export default __webpack_public_path__ + "static/media/gift-box.df3f27c8.png";